import { ApiClient } from '../api/client';
import { LoginCredentials, LoginResponse, AuthUser } from './types';

// Auth Service Interface - Interface Segregation Principle
export interface IAuthService {
  login(credentials: LoginCredentials): Promise<LoginResponse>;
  logout(): Promise<void>;
  getCurrentUser(): Promise<AuthUser>;
  verifyToken(): Promise<boolean>;
}

// Auth Service Implementation - Single Responsibility
export class AuthService implements IAuthService {
  private apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this.apiClient = apiClient;
  }

  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await this.apiClient.post<LoginResponse>('/auth/login', credentials);
    return response.data;
  }

  async logout(): Promise<void> {
    await this.apiClient.post('/auth/logout');
  }

  async getCurrentUser(): Promise<AuthUser> {
    const response = await this.apiClient.get<AuthUser>('/auth/me');
    return response.data;
  }

  async verifyToken(): Promise<boolean> {
    try {
      await this.getCurrentUser();
      return true;
    } catch {
      return false;
    }
  }
}
